import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SplashFormComponent } from "./splash-form.component";
import { FormsModule } from "@angular/forms";
import { SplashFormService } from "./Splash-form.service";
const components = [SplashFormComponent];
const providers = [SplashFormService];
@NgModule({
  declarations: [...components],
  imports: [CommonModule, FormsModule],
  exports: [...components],
  providers: [...providers],
})
export class SplashFormModule {}
